import {isFilled} from '@prismicio/helpers';
import type {LinkField} from '@prismicio/types';

export function getLink(link: LinkField) {
    if (!isFilled.link(link)) {
        return null;
    }

    const filledLink = link as {url: string; text?: string; target?: string};

    return {
        url: filledLink.url,
        text: filledLink.text ?? '',
        target: filledLink.target ?? undefined,
    };
}
